import { forwardRef, ComponentProps, createElement } from 'react'

import { styled, paperClasses, Popover as PopoverBase } from '@mui/material'
import { monthCalendarClasses, pickersMonthClasses, pickersYearClasses } from '@mui/x-date-pickers'

export const Container = styled('div')({})

const StyledPopover = styled(PopoverBase)(({ theme }) => ({
  [`& .${paperClasses.root}`]: {
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[4],
  },
}))

type PopoverComponentProps = ComponentProps<typeof PopoverBase>

export const Popover = forwardRef<HTMLDivElement, PopoverComponentProps>(function Popover(props, ref) {
  const {
    anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
    transformOrigin = { vertical: 'top', horizontal: 'left' },
    transitionDuration = 0,
    disablePortal = true,
    ...rest
  } = props

  return createElement(StyledPopover, {
    ref,
    anchorOrigin,
    transformOrigin,
    transitionDuration,
    disablePortal,
    ...rest,
  })
})

export const DatePickerWrapper = styled('div')(() => ({
  [`& .${monthCalendarClasses.root}`]: {
    [`.${pickersYearClasses.root}, .${pickersMonthClasses.root}`]: {
      '&:after': {
        content: 'unset',
      },
    },
  },
}))
